<!--
 * @Description: 网络课程单条查找带回
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2025-12-19 09:41:58
-->
<template>
  <div class="jzg_insert">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">网络课程</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>

      <el-container>
        <el-header class="pl0 pr0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>
            <el-form-item>
              <el-input placeholder="网络课程名称" v-model="dataGrid.parms.wlkcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="所属专业" v-model="dataGrid.parms.zyid" clearable filterable @change="bindTable()">
                <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select placeholder="教务课程" v-model="dataGrid.parms.kcid" clearable filterable @change="bindTable()">
                <el-option v-for="item in kcData" :key="item.id" :label="item.kcmc" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="关键字" v-model="dataGrid.parms.gjz" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
          <!-- 搜索区域 END -->
          <el-tabs v-model="activeName" class="demo-tabs" @tab-change="bindTable()">
            <el-tab-pane label="我的网络课程" name="我的网络课程"></el-tab-pane>
            <el-tab-pane label="共享课程" name="共享课程"></el-tab-pane>
          </el-tabs>
        </el-header>
        <el-main class="pl0 pb0 pr0">
          <el-table v-if="activeName=='我的网络课程'" :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <el-table-column label="网络课程名称" prop="wlkcmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span style="color: #409EFF;cursor: pointer;" @click="openWlkcDetail=true; currentRow=scope.row">{{scope.row.wlkcmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="关键字" prop="gjz" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="状态" prop="zt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" :formatter="ztFormatter" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="currentRow=scope.row;savestudent()">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
          <el-table v-if="activeName=='共享课程'" :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="序号" type="index" width="80" fixed align="center" />
            <el-table-column label="网络课程名称" prop="wlkcmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span style="color: #409EFF;cursor: pointer;" @click="openWlkcDetail=true; currentRow=scope.row">{{scope.row.wlkcmc}}</span>
              </template>
            </el-table-column>
            <el-table-column label="关键字" prop="gjz" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="是否推荐" prop="sftj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" :formatter="sftjFormatter" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="90" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="currentRow=scope.row;savestudent()">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDanTiao', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <wlkcDetail v-if="openWlkcDetail" v-model:openDetail="openWlkcDetail" :row="currentRow" />
</template>
<script setup>
import { ref, watch } from 'vue'
import { loadList, loadSelect, closeWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import wlkcDetail from '@/components/detaiWangLuoKeCheng.vue'
import { loadZiDianSelect } from '@/api/queryZiDian.js'

const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])

const savestudent = () => {
  emits('ReturnData', currentRow.value)
  handleClose()
}
const handleClose = () => {
  emits('update:openDanTiao', false)
}

const activeName = ref('我的网络课程')
const currentRow = ref()
const openWlkcDetail = ref(false)

// 加载网络教学专业下拉框
const zyData = ref([])
// 加载网络教学课程下拉框
const kcData = ref([])
// 加载网络教学创建教师下拉框
const jsData = ref([])
// 加载网络课程状态下拉框
const wlkcztData = ref({ list: [] })

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'wlkcmc', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  switch (activeName.value) {
    case '我的网络课程':
      initWode()
      break;
    case '共享课程':
      initGongXiang()
      break;
  }
}
const initWode = (pageNo, pageSize) => {
  dataGrid.value.orderBy = { prop: 'wlkcmc', order: 'ascending' },
  loadList({
    url: '/api/v2/wangluojiaoxue/wangluokecheng/my',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}
const initGongXiang = (pageNo, pageSize) => {
  dataGrid.value.orderBy = { prop: 'tjsx', order: 'ascending' },
  loadList({
    url: '/api/v2/wangluojiaoxue/wangluokecheng/gongxiangpagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
    }
  })
}
const ztFormatter = (row) => {
  const info = wlkcztData.value.list.find(item => item.value === row.zt)
  return info ? info.name : ''
}
const sftjFormatter = (row) => {
  return row.sftj ? '是' : '否'
}

watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      dataGrid.value.parms = props.row
      loadSelect({ url: '/api/v2/wangluojiaoxue/ziyuanku/zhuanyelist', data: zyData, order: 'zymc', sort: 'asc', parms: {xbid: dataGrid.value.parms.xbid || ''}})
      loadSelect({ url: '/api/v2/wangluojiaoxue/wangluojiaoxuekecheng/list', data: kcData, order: 'kcmc', sort: 'asc', parms: {xbid: dataGrid.value.parms.xbid || '' }})
      loadSelect({ url: '/api/v2/pdp/jiaozhigong/list', data: jsData, order: 'gh', sort: 'asc', parms: {xbid: dataGrid.value.parms.xbid || '' }})
      loadSelect({ url: '/api/v2/wangluojiaoxue/wangluokecheng/wangluokechengzhuangtai', data: wlkcztData})
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
</style>
